import { toLower, slice } from 'lodash/fp';
import { createSelector } from 'reselect';
import { TextKey, RouteName, SearchType } from '@mews-commander/enums';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { SearchFunction } from '../types';
import { getServicesSearchResults } from './services';
import getProfilesSearchResults from './profiles';
import getReservationsSearchResults from './reservations';
import getOperationsSearchResults from './operations';
import getFinanceSearchResults from './finance';
import getEnterpriseSearchResults from './enterprise';
import getExportsSearchResults from './exports';
import getQueuesSearchResults from './queues';
import getAnalyticsSearchResults from './analytics';
import getSettingsSearchResults from './settings';
import { getSimpleSearchResult } from './getSimpleSearchResult';

const MAX_RESULT_COUNT = 5;

const getLocalizedNavigationSearchResults = createSelector(
    getServicesSearchResults,
    getProfilesSearchResults,
    getReservationsSearchResults,
    getOperationsSearchResults,
    getFinanceSearchResults,
    getExportsSearchResults,
    getQueuesSearchResults,
    getAnalyticsSearchResults,
    getSettingsSearchResults,
    getEnterpriseSearchResults,
    getCurrentEnterpriseId,
    (
        serviceResults,
        profileResults,
        reservationResults,
        operationResults,
        financeResults,
        exportResults,
        queueResults,
        analyticsResults,
        settingsResults,
        enterpriseResults,
        enterpriseId: string
    ) => [
        ...serviceResults,
        ...profileResults,
        ...reservationResults,
        ...operationResults,
        ...financeResults,
        ...exportResults,
        ...queueResults,
        ...analyticsResults,
        ...settingsResults,
        ...enterpriseResults,
        getSimpleSearchResult({
            routeName: RouteName.DashboardIndex,
            titleKey: TextKey.Dashboard,
        }),
        getSimpleSearchResult({
            routeName: RouteName.TaskReportIndex,
            titleKey: TextKey.TaskPlural,
        }),
        getSimpleSearchResult({
            routeName: RouteName.MessageThreadIndex,
            titleKey: TextKey.MessagePlural,
        }),
        getSimpleSearchResult({
            routeName: RouteName.EnterpriseIntegrationMarketplace,
            titleKey: TextKey.Marketplace,
            params: { query: { OwnerId: enterpriseId } },
        }),
    ]
);

export const searchNavigation: SearchFunction =
    (profileId, enterpriseId, term, { startIndex }) =>
    async (_, getState) => {
        // @ts-expect-error $TSFixMeError: Expected at least 2 arguments, but got 1.
        const availableNavigationResults = getLocalizedNavigationSearchResults(getState());

        const searchTerm = toLower(term);

        const results = availableNavigationResults.filter(({ searchValue }) => searchValue.includes(searchTerm));
        const result = slice(startIndex, MAX_RESULT_COUNT, results);

        return Promise.resolve({
            searchType: SearchType.Navigation,
            result,
            hasMore: false,
        });
    };
